import { render, staticRenderFns } from "./PrivacyView.vue?vue&type=template&id=5d467570"
import script from "./PrivacyView.vue?vue&type=script&lang=ts"
export * from "./PrivacyView.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyView.vue?vue&type=style&index=0&id=5d467570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports